import Material from "../Materials"

export default 

function Wall(params) {

  const wallHeight = !params.elevation?params.dim[2]:params.dim[2]/2-params.elevation
  const wallWidth = (["a","c"].includes(params.side)?params.dim[1]:params.dim[0])-params.structuresize*2

  const elevPos = !params.elevation?0:params.elevation+wallHeight/2
  const positions = {
    "a": [ params.dim[1]/2,  params.dim[2]/2+elevPos, params.dim[0]/2-params.structuresize/2 ],
    "b": [ params.dim[1]-params.structuresize/2,  params.dim[2]/2+elevPos,  0 ],  
    "c": [ params.dim[1]/2, params.dim[2]/2+elevPos, -params.dim[0]/2+params.structuresize/2]
  }

  
  const rotations = {
    "a": [ 0,  Math.PI/2,  0 ],  //A position
    "b": [ 0,  0, 0 ],
    "c": [ 0,  -Math.PI/2, 0 ]
  }

  return (
    <mesh 
      position={positions[params.side]}
      rotation={rotations[params.side]}
      item={`wall-${params.side}`}
    >
      <Material material={params.material} type={params.type} texture={params.texture}/> 
      <boxGeometry args={[4, wallHeight, wallWidth]} />
    </mesh>
  )
}

